export class FileNameUtils {
    /**
     * Sanitizes a given string to make it safe for use as a filename prefix.
     * It removes forbidden characters, replaces whitespace, strips accents,
     * converts to lowercase, and trims trailing dots or excessive length.
     *
     * @param prefix The input string to sanitize
     * @returns A cleaned, lowercase, and filename-safe string
     */
    static sanitizeFilenamePrefix(prefix: string): string {
        return prefix
            .normalize('NFD')                      // Decompose accented characters
            .replace(/[\u0300-\u036f]/g, '')       // Remove diacritics
            .replace(/[<>:"/\\|?*\x00-\x1F]/g, '') // Remove forbidden characters
            .replace(/\s+/g, '_')                  // Replace whitespace with underscores
            .replace(/\.+$/, '')                   // Remove trailing dots
            .substring(0, 255)                     // Limit length to 255 characters
            .toLowerCase();                        // Convert to lowercase
    }
}